import { isSafari } from '../shared/is-safari';
import { width } from '../shared/width-informer';

const HREF = 'href';
const IS_ACTIVE = 'is-active';
const SRC = 'src';

const safariStyles = {
  borderColor: 'rgba(0,0,0, .25)',
  imgSrc: '/img/modal-static/shape-min.png'
};

const selectors = {
  modalContentSelector: '.js-modal-content',
  imgSelector: '.js-img',
  form: 'form',
  jsBtnModalLang: '.js-btn-modal-lang'
};

const jsClasses = {
  jsBtnModal: 'js-btn-modal',
  jsBackdropModal: 'js-backdrop-modal',
  jsMenuBtn: 'js-menu-btn',
  jsBtnModalLang: 'js-btn-modal-lang'
};

export default class Modal {
  constructor(btnSelector, modalSelector, backSelector, closeSelector) {
    if (width() >= 993) {
      document
        .querySelector(selectors.jsBtnModalLang)
        .classList.remove(jsClasses.jsBtnModal);
    }

    this.btns = document.querySelectorAll(btnSelector);
    this.modals = document.querySelectorAll(modalSelector);
    this.backdrops = document.querySelectorAll(backSelector);
    this.closeBtns = document.querySelectorAll(closeSelector);
  }

  init() {
    if (!this.check()) return;

    this.bindEvents();
  }

  bindEvents() {
    const _this = this;

    this.btns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        _this.btnHandler(e, _this);
      });
    });

    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        _this.close();
      });
    });

    this.backdrops.forEach(dropBtn => {
      dropBtn.addEventListener('click', function(e) {
        _this.backHandler(e, _this);
      });
    });

    document.body.addEventListener('keyup', () => {
      if (event.keyCode == 27) {
        _this.close();
      }
    });
  }

  backHandler(e, self) {
    if (e.target.classList.contains(jsClasses.jsBackdropModal)) {
      self.close();
    }
  }

  close() {
    this.btns.forEach(btn => {
      btn.classList.remove(IS_ACTIVE);
    });
    this.modals.forEach(modal => {
      if (modal.classList.contains('fadeIn')) {
        modal.classList.add('fadeOut');
        modal.classList.remove('fadeIn');
      }
    });

    this.modals.forEach(modal => {
      const form = modal.querySelector(selectors.form);
      if (form) {
        form.reset();
      }
    });
  }

  btnHandler(e, _this) {
    const self = e.target;
    const id = self.dataset[HREF];
    const currentModal = document.querySelector(`#${id}`);

    if (
      self.classList.contains(jsClasses.jsMenuBtn) &&
      self.classList.contains(IS_ACTIVE)
    ) {
      _this.close();
    } else {
      this.close();

      if (self.classList.contains(jsClasses.jsBtnModalLang)) {
        const menuBtn = self.parentNode.previousElementSibling;

        menuBtn.classList.add(IS_ACTIVE);
      }

      self.classList.add(IS_ACTIVE);

      setTimeout(() => {
        currentModal.classList.add('fadeIn');
        currentModal.classList.remove('fadeOut');
        const img = currentModal.querySelector(selectors.imgSelector);

        if (!isSafari) {
          if (img) {
            // set not safari img
            img.src = img.dataset[SRC];
          }
        } else {
          const modalContent = currentModal.querySelector(
            selectors.modalContentSelector
          );

          if (modalContent) {
            // set safari styles
            modalContent.style.borderColor = safariStyles.borderColor;
          }

          if (img) {
            // set safari img
            img.src = safariStyles.imgSrc;
          }
        }
      }, 250);
    }
  }

  check() {
    if (!this.btns.length > 0) {
      return false;
    }

    return true;
  }
}

const modal = new Modal(
  '.js-btn-modal',
  '.js-modal',
  '.js-backdrop-modal',
  '.js-close-modal'
);

modal.init();
